// @ts-strict-ignore
import ProductsSlider from '@components/product-slider'
import { useArticlesByIdQuery } from '@generated'
import { useEmarsysStore } from '@lib/use-emarsys-store'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

export const CartRecommendedProducts: FC = () => {
  const { recommendedProducts } = useEmarsysStore()
  const {
    i18n: { language },
  } = useTranslation()
  const [{ fetching, data }] = useArticlesByIdQuery({
    variables: { ids: recommendedProducts },
    pause: !recommendedProducts,
  })

  return (
    <ProductsSlider
      emarsysContainerId="recommended-products-cart"
      isLoading={fetching || !recommendedProducts}
      title={language === 'nl' ? 'Aanbevolen producten' : 'Recommended products'}
      articles={data && data.articlesById}
      mt={['4rem', '4rem', '6.5rem']}
    />
  )
}
